import React from "react";
import CardActions from "@mui/material/CardActions";
import Button from "@mui/material/Button";
import {makeStyles} from "@mui/styles";

// Style für DataTreeView
const useStyles = makeStyles({
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
});

function DetailItemInfo({item, openDetailView}) {
    const classes = useStyles();
    const bull = <span className={classes.bullet}>•</span>;
    const type = item.administrativeobjectType ? item.administrativeobjectType : item.realestateobjectType;
    return (
        <>
            <div>{item.name}{bull}{item.number}{bull}{item.label}</div>
            <div>{type}</div>
            <CardActions>
                <Button size="small" onClick={() => openDetailView(item.guid)}>Details</Button>
            </CardActions>
        </>
    );
}

export default DetailItemInfo;
